<template lang="pug">
  DefaultLayout
    div Добавление команды
      BaseInput(v-model="teamName")
      Btn(@click="addTeam") Добавить команду
    br
    div Ваши команды:
      div(v-for="t in teams") {{ t.name }}
        Btn(@click="delTeam(t)") Удалить
        Btn(@click="teamId = t.id") Выбрать
    br
    div(v-if="team") Участники команды {{ team.name }}
      Btn(@click="addUser") Добавить участника
      div(v-for="member in team.teamMembers")
        UserTile(:user="member.user")
        Btn(@click="delUser(member)") Удалить
    UserSelectPopup2(ref="userSelectPopup")
</template>

<script>
import teamApi from '@/api/team';
import teamMemberApi from '@/api/teamMember';

import DefaultLayout from '@/layouts/Default.vue';
import BaseSelect from '@/components/BaseSelect.vue';
import BaseInput from '@/components/BaseInput.vue';
import UserTile from '@/components/UserTile.vue';
import UserSelectPopup2 from '@/components/UserSelectPopup2.vue';

export default {
  name: 'Home',
  components: {
    DefaultLayout,
    BaseSelect,
    BaseInput,
    UserTile,
    UserSelectPopup2,
  },
  data() {
    return {
      teamName: '',
      teamId: null,
      teams: [],
    };
  },
  computed: {
    team() { return this.teams.find(t => t.id === this.teamId); },
  },
  mounted() {
    teamApi.fetchList({}, true).then(r => { this.teams = r.items; });
  },
  methods: {
    async addTeam() {
      await teamApi.create({ name: this.teamName }, true);
      teamApi.fetchList({}, true).then(r => { this.teams = r.items; });
    },
    async delTeam(team) {
      await teamApi.delete(team.id, true);
      teamApi.fetchList({}, true).then(r => { this.teams = r.items; });
    },
    async delUser(member) {
      await teamMemberApi.delete(member.id, true);
      teamApi.fetchList({}, true).then(r => { this.teams = r.items; });
    },
    async addUser() {
      const usersBeforeSelect = (this.team.teamMembers ?? []).map((m) => m.user['@id']);
      const selectedUsers = await this.$refs.userSelectPopup.open(usersBeforeSelect, true);

      if (!selectedUsers) return;

      selectedUsers.forEach(async (user) => {
        if (usersBeforeSelect.includes(user['@id'])) return;
        await teamMemberApi.create({ team: this.team['@id'], user: user['@id'] }, true);
        teamApi.fetchList({}, true).then(r => { this.teams = r.items; });
      });

    },
  },
};
</script>

<style scoped lang="scss">
  .grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 37px 42px;
    align-items: stretch;
  }

  .wide, .notifications, .contacts, .projects {
    grid-column: 2 span;
  }

  .header {
    display: flex;
    justify-content: space-between;
    gap: 12px;
    align-items: center;
    margin-bottom: 30px;
    height: 26px;

    &.short {
      margin-bottom: 10px;
    }
  }

  .title {
    font-weight: 500;
    font-size: 18px;
    line-height: 24px;
    color: #232226;
    margin-right: auto;
  }

  .block {
    display: flex;
    flex-direction: column;
  }

  .content {
    flex-grow: 1;
  }

  @media (max-width: 1500px) {
    .grid {
      display: grid;
      grid-template-columns: repeat(2, 1fr);
    }

    .personal {
      grid-column: 2 span;
    }

    .personal-stats {
      flex-direction: column;
    }

    .projects {
      grid-column: 1 span;
    }

    .news {
      grid-row: 5;
    }

  }

  @media (max-width: 992px) {
    .tariffs, .projects {
      grid-column: 2 span;
    }
  }

  @media (max-width: 768px) {

    .grid {
      grid-template-columns: 1fr;
    }

    .wide, .personal, .tariffs, .projects {
      grid-column: 1 span;
    }

    .news {
      grid-row: 7;
    }
  }

</style>
